export const RemoveKendoReactWatermarks = () => {
    const notLicensedWatermarks = document.querySelectorAll("div[style*='pointer-events: none;']");
    notLicensedWatermarks.forEach(item => {
        item.style.display = "none";
    });

    const notLicensedBanners = document.querySelectorAll("div[style*='background-color: rgb(255, 192, 0);']");
    notLicensedBanners.forEach(item => {
        item.style.display = "none";
    });
}